export const getRatio = (): number => {
  return window.innerWidth / window.innerHeight
}
